import InfoTooltip from 'assets/images/infoTooltip.svg?react';
import React, { useState } from 'react';
import InfoDialogCard from 'shared/components/dialog/infoDialog';
import './styles.scss';

interface Props {
	dialogTitle?: string;
	dialogContent?: string;
	cyTestRef?: string;
	cyDescriptionTestRef?: string;
	cyActionTextRef?: string;
}

const TooltipModal: React.FC<Props> = (props) => {
	const { dialogTitle, dialogContent } = props;

	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<div className="infoTooltip" style={{ zIndex: '0 !important' }} onClick={() => setIsOpen(true)} data-cy={props.cyTestRef}>
				<InfoTooltip className="infoTooltip__icon" />
			</div>
			{isOpen && (
				<InfoDialogCard
					iconTitle={dialogTitle}
					subTitle={dialogContent}
					onClose={() => setIsOpen(false)}
					cyDescriptionTestRef={props.cyDescriptionTestRef}
					cyActionTextRef={props.cyActionTextRef}
				/>
			)}
		</>
	);
};

export default TooltipModal;
